module.exports = __webpack_public_path__ + "img/stackoverflow.357bebf2.svg";